import Mapper from '@/models/mappers/Mapper';
import { QuantityBreakDTO } from '@/api/dto/QuantityBreakDTO';
import { mapValueToInterface } from '@/utils/models';
import { QuantityBreak } from '@/models/entities/QuantityBreak';

export class QuantityBreakMapper extends Mapper<QuantityBreak, QuantityBreakDTO> {
  mapFromDTO(quantityBreakDTO: QuantityBreakDTO): QuantityBreak {
    return new QuantityBreak(<Partial<QuantityBreak>>quantityBreakDTO);
  }

  mapToDTO(quantityBreak: QuantityBreak): QuantityBreakDTO {
    return mapValueToInterface(quantityBreak) as QuantityBreakDTO;
  }
}
